export default __webpack_public_path__ + "static/media/ico_more_line.17a1b409.svg";